import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { TrackingService2, TrackingService2Symbol, createCommand } from '@/app/tracking/api';
import { QuestionAttemptStoreModule, QuestionAttemptStoreModuleSymbol } from '../../store'
import { AddQuestionAttemptsTrackingCommand } from '../../tracking/api';

interface QuestionAttempt {
  id: string
  attempt: {
    thinkingTimeSeconds: number
    achievedScore: number
  }
}

export type AddQuestionAttemptCommandPayload = QuestionAttempt[]

const debug = Debug('add-question-attempt-command-handler')

@injectable()
export class AddQuestionAttemptCommandHandler {

  constructor(
    @inject(QuestionAttemptStoreModuleSymbol)
    private questionAttemptStoreModule: QuestionAttemptStoreModule,
    @inject(TrackingService2Symbol)
    private trackingService: TrackingService2) {

  }

  execute(attempts: QuestionAttempt[]) {
    debug('execute', attempts)

    this.questionAttemptStoreModule.addAttempts(attempts)

    const trackingCommand = createCommand<AddQuestionAttemptsTrackingCommand>(
      'add-question-attempts', attempts.map(x => ({
        id: x.id,
        attempts: [ x.attempt ]
      })))
    
    this.trackingService.execute(trackingCommand)
  }
}
